import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DoHttpService } from 'src/app/core/services/do-http.service';
import { UserDetailService } from 'src/app/core/services/user-detail.service';
import { ApiUrls } from 'src/app/shared/constants/ApiUrls';
import {
	ProductTypeEnum,
	RegistrationPageAppDisplayNames,
} from 'src/app/shared/enum/ProductTypeEnum';
import {
	BillingCycle,
	RegistrationPageViewModeEnum,
	SubscriptionPlan,
	SubscriptionState,
	UserAddon,
} from 'src/app/shared/interfaces/ISubscription';

@Component({
	selector: 'app-purchase-new-product',
	templateUrl: './purchase-new-product.component.html',
	styleUrls: ['./purchase-new-product.component.scss'],
})
export class PurchaseNewProductComponent implements OnInit {
	subscriptionState: SubscriptionState;
	step: number = 1;
	appNames = RegistrationPageAppDisplayNames;
	selectedCountryCurrency: string = 'DKK';
	selectedBillingCycle: string = 'Yearly';
	productPurchaseStatus: 'awaiting' | 'success' | 'failure' | null = null;
	selectedPlans: SubscriptionPlan[] = [];
	totalCost: number = 0;
	userSlabs: UserAddon[] = [];
	availablePlans: SubscriptionPlan[] = [];
	isLoading: boolean = true;
	planSelectorBackButtonEnabled: boolean;
	availableSketchApps = [];
	isPaymentSelected = false;
	productTypeFromQuery = null;
	productTypeEnum = ProductTypeEnum;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private request: DoHttpService,
		private userDetailService: UserDetailService,
	) { }

	ngOnInit(): void {
		this.route.queryParams.subscribe((params) => {
			const productType = Number.parseInt(params.productType);

			if (
				Number.isNaN(productType) ||
				productType > 10 ||
				productType <= 0
			) {
				this.router.navigate(['/home']);
			}

			this.checkIfAlreadySubscribed(productType);
			this.productTypeFromQuery = productType;
			// this.step = productType === 10 ? 2 : 1;
			this.step = 1;
			this.planSelectorBackButtonEnabled = productType === 10 ? true : false;
			this.subscriptionState = {
				selectedApp: productType === 10 ? ProductTypeEnum.EplanSketch : productType,
				viewMode: RegistrationPageViewModeEnum.single,
				selectedPlans: {
					1: null,
					2: null,
					3: null,
					4: null,
					5: null,
					6: null,
					7: null,
					8: null,
					9: null,
					10: null,
				},
			};
		});

		this.getAvailablePlans();
	}

	checkIfAlreadySubscribed(productType: ProductTypeEnum) {
		if (productType === ProductTypeEnum.DrawoutApp && this.userDetailService.getUserData().isWorkspaceAvailable) this.goToHomePage();
		if (productType === ProductTypeEnum.Testspace && this.userDetailService.getUserData().isTestspaceAvailable) this.goToHomePage();
		if (productType === ProductTypeEnum.LegacyZen && this.userDetailService.getUserData().isConfigurationAvailable) this.goToHomePage();

		this.request.get(ApiUrls.getAvailableSketchApps).subscribe(res => {
			this.availableSketchApps = res.map(item => item.productId);
			if (this.availableSketchApps.includes(productType)) this.goToHomePage();
		})
	}

	getAvailablePlans() {
		const url = ApiUrls.getAllSubscriptionPlans;
		this.request.get(url).subscribe({
			next: (res) => {
				this.availablePlans = res;
				setTimeout(() => {
					this.isLoading = false;
				}, 500)
			},
			error: (res) => { },
		});
	}

	// onSketchVariantSelection(e) {
	// 	this.subscriptionState.selectedApp = e.sketchVariantProductType;
	// 	this.step = 1;
	// }

	goToNextStep(): void {
		this.step = 2;
	}

	goToPreviousStep(): void {
		this.step = 1;
	}

	calculateSummaryGoGorward() {
		this.selectedPlans = [];
		const selectedPlan = Object.entries(this.subscriptionState.selectedPlans)
			.filter(([key, value]) => value !== null)[0];
		const currentlySelectedPlan = this.availablePlans.find(plan => plan.subscriptionTierId === selectedPlan[1]);
		this.selectedPlans.push(currentlySelectedPlan);
		this.calculateTotalUserCount(currentlySelectedPlan);
		this.calculateAddOnCost(currentlySelectedPlan);
		this.recalculateOrderTotal();
		this.goToNextStep();
	}


	// subscriptionStateChanged(event) {
	// 	this.selectedPlans = [];
	// 	this.subscriptionState = event;
	// 	const selectedPlan = Object.entries(
	// 		this.subscriptionState.selectedPlans
	// 	).filter(([key, value]) => value !== null)[0];
	// 	const currentlySelectedPlan = this.availablePlans.find(
	// 		(plan) => plan.subscriptionTierId === selectedPlan[1]
	// 	);
	// 	this.selectedPlans.push(currentlySelectedPlan);
	// 	this.calculateTotalUserCount(currentlySelectedPlan);
	// 	this.calculateAddOnCost(currentlySelectedPlan);
	// 	this.recalculateOrderTotal();
	// }

	// onBillingCycleChanged(e) {
	// 	this.selectedBillingCycle = e;
	// 	this.selectedPlans.forEach((plan) => {
	// 		this.calculateTotalUserCount(plan);
	// 		this.calculateAddOnCost(plan);
	// 	});
	// 	this.recalculateOrderTotal();
	// }

	calculateTotalUserCount(plan: SubscriptionPlan) {
		plan.totalUserCount = plan.numberOfUsers + plan.addOnCount;
	}

	calculateAddOnCost(plan?: SubscriptionPlan) {
		if (!plan || !(plan.addOnCount > 0)) return;
		let matchedSlab: UserAddon | undefined;
		for (const slab of this.userSlabs) {
			if (slab.productType !== plan.productType) continue;

			if (
				slab.userRangeTo === null ||
				slab.unlimitedUsers ||
				plan.totalUserCount <= slab.userRangeTo
			) {
				matchedSlab = slab;
				break;
			}
		}
		if (!matchedSlab) return;
		plan.addOnSlab = matchedSlab;

		const addOnRates = plan.addOnSlab.userSlabRates.find(
			(slabRate) => slabRate.currency === this.selectedCountryCurrency
		);
		const addOnRate =
			this.selectedBillingCycle === 'Monthly'
				? addOnRates.monthlyPrice
				: addOnRates.yearlyPrice;
		plan.addOnRate = addOnRate;
		plan.addOnCost = plan.addOnCount * addOnRate;
	}

	recalculateOrderTotal() {
		let total = 0;
		for (const plan of this.selectedPlans) {
			let rates = plan.tierRates.find(
				(rate) => rate.currency === this.selectedCountryCurrency
			);
			let rate =
				this.selectedBillingCycle === 'Monthly'
					? rates.monthlyRate
					: rates.yearlyRate;
			plan.rate = rate;
			total += rate + (plan.addOnCost ?? 0);
		}
		this.totalCost = total;
	}

	purchaseProduct() {
		const selectedPlan = this.selectedPlans[0];
		const billingCycle = this.selectedBillingCycle === 'Monthly' ? BillingCycle.Monthly : BillingCycle.Annually;
		const apiUrl = ApiUrls.purchaseProduct(selectedPlan.subscriptionTierId, billingCycle);
		this.productPurchaseStatus = 'awaiting';
		this.request.post(apiUrl, '').subscribe({
			next: (res) => {
				this.productPurchaseStatus = 'success';
			},
			error: (err) => {
				console.error(err);
				this.productPurchaseStatus = 'failure';
			},
		});
	}

	goToHomePage() {
		this.router.navigate(['/home']);
	}
}
